import React from 'react';
import RedirectLink from 'app/components/auth/RedirectLink';
import { useI18n } from 'app/components/localization';
import { LoginRoute, ForgotPasswordRoute, ResetPasswordRoute } from 'app/constants/Routes';
import { parseUrlLoose } from 'app/utils/LooseURL';
import { CallbackRef } from 'app/utils/react';

const noRedirectConditions = [
  (redirectTo: string) => ForgotPasswordRoute.match(parseUrlLoose(redirectTo).pathname),
  (redirectTo: string) => ResetPasswordRoute.match(parseUrlLoose(redirectTo).pathname),
];

interface ILoginLinkProps {
  className?: string;
  getRef?: CallbackRef;
}

const LoginLink: React.SFC<ILoginLinkProps> = ({
  className,
  children,
  getRef,
}) => {
  const { t } = useI18n();
  return (
    <RedirectLink
      className={className}
      getRef={getRef}
      to={LoginRoute.getPathname()}
      noRedirectConditions={noRedirectConditions}
    >
      {children || t('header.login-link')}
    </RedirectLink>
  );
};

export default LoginLink;
